import ShDividerLine from '@/components/Helpers/ShDividerLine';

// @vue/component
export default {
  name: 'CopyrightSection',

  components: { ShDividerLine },
};
